export const HISTORY_FILTER_ALL = "all";
export const HISTORY_FILTER_MASTERY = "mastery_level";
export const HISTORY_FILTER_CAPTURE = "word_capture";
export const HISTORY_FILTER_HUNTER = "hunter_level";
export const HISTORY_FILTER_DAILY_QUEST = "daily_quest";

export const HISTORY_FILTER_OPTIONS = [
  { value: HISTORY_FILTER_ALL, label: "Tout afficher" },
  { value: HISTORY_FILTER_MASTERY, label: "Passages de niveaux" },
  { value: HISTORY_FILTER_CAPTURE, label: "Capture de mot" },
  { value: HISTORY_FILTER_DAILY_QUEST, label: "Quête journalière" },
];

export const HISTORY_FILTER_LS_KEY = "vocabularium_history_filter";

const VALID_HISTORY_FILTERS = new Set(
  HISTORY_FILTER_OPTIONS.map((option) => option.value)
);

export function readHistoryFilter() {
  try {
    const raw = localStorage.getItem(HISTORY_FILTER_LS_KEY);
    return VALID_HISTORY_FILTERS.has(raw) ? raw : HISTORY_FILTER_ALL;
  } catch {
    return HISTORY_FILTER_ALL;
  }
}

export function writeHistoryFilter(value) {
  if (!VALID_HISTORY_FILTERS.has(value)) return;
  try {
    localStorage.setItem(HISTORY_FILTER_LS_KEY, value);
  } catch {
    // quota / mode privé : on ignore
  }
}

export function resolveHistoryEntryType(entry) {
  if (entry?.type) return entry.type;
  if (entry?.direction) return HISTORY_FILTER_MASTERY;
  return HISTORY_FILTER_CAPTURE;
}

export function filterHistoryEntries(entries, filter) {
  const visible = (entries || []).filter(
    (entry) => resolveHistoryEntryType(entry) !== HISTORY_FILTER_HUNTER
  );
  if (filter === HISTORY_FILTER_ALL) return visible;
  return visible.filter((entry) => resolveHistoryEntryType(entry) === filter);
}

export function getHistoryFilterEmptyMessage(filter) {
  switch (filter) {
    case HISTORY_FILTER_MASTERY:
      return "Aucun passage de niveau enregistré.";
    case HISTORY_FILTER_CAPTURE:
      return "Aucune capture de mot enregistrée.";
    case HISTORY_FILTER_DAILY_QUEST:
      return "Aucune quête journalière accomplie enregistrée.";
    default:
      return "Aucun événement enregistré.";
  }
}
